import { useMutation, useQueryClient } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { deleteOptInFeature } from '../Services/OptInFeatures.service';
import { useActionToast } from '@/Hooks/useActionToast';

export const useDeleteOptInFeature = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: (id: string) => deleteOptInFeature(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: optInFeaturesQueryKeys.lists() });
      toast.success('Funcionalidade excluída');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível excluir a funcionalidade', error);
    },
  });
};
